import { Component, OnInit } from '@angular/core';
import { IListInfo } from '@pnp/sp/presets/all';
import { ISiteUserInfo } from '@pnp/sp/site-users/types';
import { CurrentUserService } from '../services/current-user.service';
import { ErrorService } from '../services/error.service';
import { UserCertification } from '../services/models';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})

export class HomeComponent implements OnInit {

  currentUserCert: UserCertification;
  currentUser: ISiteUserInfo;
  today = new Date();
  isLoading = true;
  isSavingCertification = false;

  constructor(private usersService: UsersService,
    private currentUserService: CurrentUserService,
    private errorService: ErrorService) { }

  async ngOnInit(): Promise<void> {
    try {
      this.currentUser = await this.currentUserService.get();
      this.currentUserCert = await this.usersService.getUserCertification(this.currentUser.Id);
    }
    catch (error) {
      this.errorService.show('Failed to get data from SharePoint server', error);
    }
    this.isLoading = false;
  }

  get isUserCertificated(): boolean {
    return this.currentUserCert && this.currentUserCert.ExpirationDate && this.today.getTime() < this.currentUserCert.ExpirationDate.getTime();
  }

  getType(list: IListInfo): any {
    if (list.BaseType === 0) { return 'List'; }
    else if (list.BaseType === 1) { return 'Document Library'; }
    return list.BaseType;
  }

  async acceptCertification() {
    const certification: UserCertification = {
      CertificationDate: new Date()
    };
    this.isSavingCertification = true;
    try {
      if(this.currentUserCert !== undefined && this.currentUserCert.Id !== undefined && this.currentUserCert.Id > 0) {
        certification.Id = this.currentUserCert.Id;
        await this.usersService.updateUserCertification(certification);
      }
      else {
        certification.Title = this.currentUser.Title;
        await this.usersService.createUserCertification(certification);
      }
      this.currentUserCert = await this.usersService.getUserCertification(this.currentUser.Id);
    }
    catch (error) {
      this.errorService.show('Failed to save certification', error);
    }
    this.isSavingCertification = false;
  }
}
